const presentation_video_element = document.querySelector('#Presentation');
const slides_container = document.querySelector('#SlidesContainer');

if( presentation_video_element && slides_container ) {

  const videoController = new VideoControler( presentation_video_element );
  const slideControler = new SlideControler( slides_container );
    slideControler.connect_videocontroler(videoController);
    slideControler.start();

  window.slideControler = slideControler; // beschikbaar voor andere files

}

//
// Responsive video source
//

(function() {

  var currentsource = false;
  const video = document.getElementById('Presentation');

  if( video && (video != undefined) && (video != null) ) {
    const smallSrc = 'https://player.vimeo.com/progressive_redirect/playback/938204347/rendition/1080p/file.mp4?loc=external&log_user=0&signature=bf64b0ceccdb4b6c18971e434944af6af183f803ff070476fccb6cca49480167';
    const largeSrc = 'https://player.vimeo.com/progressive_redirect/playback/938190472/rendition/1080p/file.mp4?loc=external&log_user=0&signature=676bd558fa36d55114ae994da92064ed9855a15031a2354e02f3a3f4a9b8e986';

    function updateVideoSource( init ) {
      if (window.innerWidth < 1200) { // mobile

        if( currentsource == false || currentsource != smallSrc ) {
          let currenttime = video.currentTime;
          let is_playing = (video.currentTime > 0) && (!video.paused) && (!video.ended);
          currentsource = smallSrc;
          video.src = smallSrc;
          video.currentTime = currenttime;
          video.load();
          if( is_playing || init ) video.play();
        }

      } else { // desktop

        if( currentsource == false || currentsource != largeSrc ) {
          let currenttime = video.currentTime;
          let is_playing = (video.currentTime > 0) && (!video.paused) && (!video.ended);
          currentsource = largeSrc;
          video.src = largeSrc;
          video.currentTime = currenttime;
          video.load();
          if( is_playing || init ) video.play();
        }

      }
    }

    currentsource = video.src;
    updateVideoSource(true);

    window.onresize = function() {
      updateVideoSource(false);
    };
  }

})();